import React from 'react';

/**
 * PiStopBigSolid icon from the solid style in media category.
 */
interface PiStopBigSolidProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiStopBigSolid({
	size = 24,
	color,
	className,
	ariaLabel = 'stop-big icon',
	...props
}: PiStopBigSolidProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				d="M4 9.8c0-1.787 0-2.753.436-3.608a4 4 0 0 1 1.748-1.748C7.04 4 8.006 4 9.8 4h4.4c1.787 0 2.753 0 3.608.436a4 4 0 0 1 1.748 1.748C20 7.04 20 8.006 20 9.8v4.4c0 1.787 0 2.753-.436 3.608a4 4 0 0 1-1.748 1.748C16.96 20 15.994 20 14.2 20H9.8c-1.787 0-2.753 0-3.608-.436a4 4 0 0 1-1.748-1.748C4 16.96 4 15.994 4 14.2z"
				fill="currentColor"
			/>
		</svg>
	);
}
